import { api } from "./api.v2";

const BASE = "/pagina-links";

const buildPageFormData = (pageData, heroImageFile, buttons = [], carouselFiles = [], buttonsToDelete = [], carouselToDelete = []) => {
  const fd = new FormData();

  Object.entries(pageData).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, String(v));
  });

  if (heroImageFile) fd.append("hero_image", heroImageFile);

  // Botões: ícones enviados como button_icon_{i} onde i = índice no array
  const buttonsJson = buttons.map((b, i) => {
    if (b._iconFile) fd.append(`button_icon_${i}`, b._iconFile);
    return {
      id: b.id,
      label: b.label,
      href: b.href,
      icon: b._iconFile ? null : (b.icon ?? null), // será substituído pelo upload no backend
      bg_color: b.bg_color,
      text_color: b.text_color,
    };
  });
  fd.append("buttons_json", JSON.stringify(buttonsJson));

  // Carousel: arquivos repetidos no mesmo campo "carousel_files"
  carouselFiles.forEach((file) => fd.append("carousel_files", file));

  if (buttonsToDelete.length)
    fd.append("buttons_to_delete", JSON.stringify(buttonsToDelete.map((b) => b.id)));
  if (carouselToDelete.length)
    fd.append("carousel_to_delete", JSON.stringify(carouselToDelete.map((c) => c.id)));

  return fd;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  listar: () => api.get(BASE),

  buscarPorId: (id) => api.get(`${BASE}/${id}`),

  criar: (pageData, heroImageFile, buttons, carouselFiles) => {
    const fd = buildPageFormData(pageData, heroImageFile, buttons, carouselFiles);
    return api.post(BASE, fd, { headers: { "Content-Type": "multipart/form-data" } });
  },

  atualizar: (id, pageData, heroImageFile, buttons, carouselFiles, buttonsToDelete, carouselToDelete) => {
    const fd = buildPageFormData(pageData, heroImageFile, buttons, carouselFiles, buttonsToDelete, carouselToDelete);
    return api.put(`${BASE}/${id}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  },

  deletar: (id) => api.delete(`${BASE}/${id}`),

  uploadImagem: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`${BASE}/upload-image`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Buttons (kept for potential isolated use)
  criarBotao: (pageId, payload) => api.post(`${BASE}/${pageId}/buttons`, payload),

  atualizarBotao: (pageId, buttonId, payload) =>
    api.put(`${BASE}/${pageId}/buttons/${buttonId}`, payload),

  deletarBotao: (pageId, buttonId) =>
    api.delete(`${BASE}/${pageId}/buttons/${buttonId}`),

  // Carousel (kept for potential isolated use)
  criarCarousel: (pageId, payload) => api.post(`${BASE}/${pageId}/carousel`, payload),

  deletarCarousel: (pageId, imageId) =>
    api.delete(`${BASE}/${pageId}/carousel/${imageId}`),
};
